import { connect } from 'react-redux'
import Password from './password'
import {
  getUser,
  getUpdateAccountRequest
} from '../../../../stores/user/user.selectors'
import { updateUserPassword } from '../../../../stores/user/user.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = state => {
  const user = getUser(state)
  const updateAccountDetails = getUpdateAccountRequest(state)
  return {
    pending: updateAccountDetails.pending,
    emailId: user.email_identity && user.email_identity.id,
    email: user.email_identity && user.email_identity.email
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }) => ({
  ...stateProps,
  onSubmit: values => {
    const data = {
      current_password: values.currentPassword,
      password: values.password,
      password_confirmation: values.repeatPassword
    }
    dispatch(updateUserPassword(stateProps.emailId, data))
      .then(() => toast.success('Your password was successfully updated.'))
      .catch(errorHandler)
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(Password)
